import { useCallback } from 'react'
import { api } from '../api/client'

/**
 * Hook for tracking analytics events. Fire-and-forget; errors are silently ignored.
 */
export function useTrackEvent() {
  const trackEvent = useCallback(
    (eventType: string, eventName: string, metadata?: Record<string, unknown>) => {
      api
        .post('/api/analytics/event', {
          event_type: eventType,
          event_name: eventName,
          metadata: metadata || {},
        })
        .catch(() => {
          /* analytics are best-effort */
        })
    },
    [],
  )

  return trackEvent
}
